export function formatCpf(value: string): string {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, '$1.$2') 
    .replace(/(\d{3})(\d)/, '$1.$2') 
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2'); 
};

export function formatCnpj(cnpj: string): string {
  return cnpj
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 18);
};

export function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, "").slice(0, 11);

  if (cleaned.length <= 10) {
    // landline
    return cleaned
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d{1,4})/, "$1-$2");
  }

  // mobile
  return cleaned
    .replace(/^(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{1,4})/, "$1-$2");
};

export const formatPostalCode = (value: string) => {
  const digitsOnly = value.replace(/\D/g, "").slice(0, 8);

  if (digitsOnly.length <= 5) {
    return digitsOnly;
  }
  
  return `${digitsOnly.slice(0, 5)}-${digitsOnly.slice(5)}`;
};

export const formatPriceBRL = (value: number | null): string => {
  if (value === null) {
    return "";
  }

  const htmlCurrency = typeof document !== "undefined"
    ? document.documentElement?.dataset?.currency
    : undefined;
  const currencyCode = (htmlCurrency || "BRL").trim().toUpperCase();
  const locale = currencyCode === "USD"
    ? "en-US"
    : currencyCode === "EUR"
      ? "es-ES"
      : "pt-BR";

  const rounded = Number(value.toFixed(2));

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
  }).format(rounded);
};

export function unformat(value: string | null): string {
  if (!value) {
    return "";
  }
  
  return value.replace(/\D/g, "");
};

export const formatDateToBR = (dateStr: string): string => {
  const date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
};

export const formatDateTimeToBR = (date: string | Date): string => {
  const parsedDate = new Date(date);

  return parsedDate.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

export function formatBankAccountNumber(account: string): string {
  return account
    .replace(/\D/g, '')
    .replace(/^(\d{1,6})(\d)/, '$1-$2')
    .slice(0, 8);
};

// The "all" option of a list follows the list: uppercase when every name is, written normally otherwise
export const matchListCase = (label: string, names: string[]) => {
  const isAllUppercase = names.length > 0 && names.every((name) => name === name.toLocaleUpperCase('pt-BR'));
  return isAllUppercase ? label.toLocaleUpperCase('pt-BR') : label;
};

// "1 dia útil" / "5 dias úteis": carriers count business days, so the text always says so
export const formatBusinessDays = (days: number): string =>
  `${days} ${days > 1 ? "dias úteis" : "dia útil"}`;

// One wording for delivery time wherever shipping is shown (product modal, cart, checkout).
// "até" because the carrier quotes a maximum, not an exact day.
export const formatDeliveryTime = (days: number | null | undefined): string =>
  days != null && days > 0 ? `Entrega em até ${formatBusinessDays(days)}` : "Prazo a definir";
